
import {
    GET_DEFINITION_ACTION_TYPE
} from '../sagas/getDefinition';

const initialState = {
    initialized: false,
    loading: false,
    searchDefinition: null
};

export function getQuery(state, queryId) {
    return state.searchDefinition.reduce((previous, current) => {
        return (current.id === queryId)
            ? current
            : previous;
    }, null);
}

function definition(state = initialState, action) {
    switch (action.type) {
        case GET_DEFINITION_ACTION_TYPE.LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_DEFINITION_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                searchDefinition: action.searchDefinition,
                loading: false
            };
        case GET_DEFINITION_ACTION_TYPE.FAILED:
            return {
                ...state,
                searchDefinition: null,
                loading: false
            };
        default:
            return state;
    }
}

export default definition;
